/**
 * Organization-scoped application feature flags (canonical source of truth).
 *
 * Stored as boolean sub-extensions on the entity-root Organization under the
 * `organization-feature-flags` extension (canonical URL in
 * `ALOPEX_STRUCTURE_DEFINITIONS.ORGANIZATION_FEATURE_FLAGS`). Each key below is
 * a sub-extension url (`Extension.extension.url`); an absent sub-extension means
 * the feature is off.
 *
 * Read by all users through the `User/$get-permissions` operation and written on
 * the entity-root org via the `entity_admin`-gated set-feature-flags operation.
 * Consumed by both the web app and the Medplum bots.
 */
export const ORGANIZATION_FEATURE_FLAGS = {
    PHYSICIAN_SUMMARY: 'physicianSummary',
    AI_ASSISTANT: 'aiAssistant',
};
export const DEFAULT_ORGANIZATION_FEATURE_FLAGS = Object.fromEntries(Object.values(ORGANIZATION_FEATURE_FLAGS).map((key) => [key, false]));
